import { convertToEnglishDigits } from '@/common/components/base/input/base/changeHandlers/convertToEnglishDigits';
import Input from '@/common/components/base/input/base/Input.tsx';
import { NumberInputType } from '@/common/components/base/input/textInput copy/NumberInput.type';
import { ChangeEventHandler } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { css, cx } from 'styled-system/css';

const NumberInput = ({
  name,
  rules,
  placeholder,
  onChange,
  disabled,
  defaultValue = '',
  className,
  maxLength,
  inputProps,
  ...props
}: NumberInputType) => {
  const { control } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });
  const {
    field,
    //  fieldState
  } = controller;
  // const errorMessage = fieldState.error?.message;
  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    let value = convertToEnglishDigits(e.target.value);

    value = value.replace(/\D/g, '');
    if (maxLength && value.length > maxLength) {
      value = value.slice(0, maxLength);
    }
    field.onChange(value);
    onChange?.(value);
  };

  return (
    <Input
      inputRef={field.ref}
      inputProps={{
        value: field.value,
        onChange: inputOnChange,
        placeholder,
        disabled,
        type: 'tel',
        className: cx(inputStyle, className),
        ...inputProps,
      }}
      hasLabel={false}
      hasErrorMassage={false}
      {...props}
    />
  );
};

export default NumberInput;

const inputStyle = css({
  '&::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '&::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '&': {
    appearance: 'textfield',
  },
});
